<template>
  <div id="schools-teachers">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="schools-teachers-table" fluid>
      <b-row class="mt-4">
        <b-col>
          <div class="table-wrap">
            <br />
            <b-col>
              <h4 class="subtitle">
                Schools's Current Teachers ({{ teachersTable.length }})
              </h4>
              <b-form-group>
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="schoolTeacherFields"
              :items="teachersTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <!-- <template v-slot:cell(first_name)="data"> -->
              <template slot="cell(first_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditTeacher',
                    params: { id: row.item.teacher_uuid },
                  }"
                >
                  <!-- {{data.item.first_name}} {{data.item.last_name}} -->
                  {{ row.item.first_name }} {{ row.item.middle_name }}
                  {{ row.item.last_name }}
                </b-link>
              </template>
              <template slot="cell(head_teacher)" slot-scope="row">
                {{ row.item.head_teacher === true ? "Y" : "N" }}
              </template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  v-if="isAdmin || isSRC"
                  :id="row.item.id.toString()"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateSchoolTeacher(row)"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  v-if="isAdmin || isSRC"
                  @click.stop="deleteSchoolTeacher(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col>
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col v-if="isAdmin || isSRC">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Teachers</h4>
            <div v-if="showForm">
              <name-search table="teachers"></name-search>
              <br />
            </div>
            <div v-if="cleanedSearchResults.length">
              <b-col>
                <h6 class="subtitle">
                  Results: {{ getTeacherSearchResults.length }} teachers found
                </h6>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      v-model="filterSearchResults"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-btn
                        :disabled="!filterSearchResults"
                        @click="filterSearchResults = ''"
                        >Clear</b-btn
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div id="alerts" ref="school-teachers-alert">
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                    >You have successfully added a teacher!</b-alert
                  >
                  <b-alert :show="showError" dismissible variant="warning">
                    Something went wrong. Please refresh and try again, or
                    contact the site admin.
                  </b-alert>
                </div>
              </b-col>
              <b-table
                v-cloak
                responsive
                :fields="searchResultsFields"
                :items="cleanedSearchResults"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(first_name)" slot-scope="row">
                  <b-link
                    @click.stop="stopClick"
                    :to="{
                      name: 'EditTeacher',
                      params: { id: row.item.teacher_uuid },
                    }"
                    >{{ row.item.teacher_name }}</b-link
                  >
                  <br />
                  <p class="small-date">created: {{ row.item.created }}</p>
                  <p class="small-date">
                    Head Teacher?:
                    {{ row.item.head_teacher === true ? "Y" : "N" }}
                  </p>
                </template>
                <template slot="cell(sex)" slot-scope="row">
                  {{ row.item.sex === "male" ? "M" : "F" }}
                </template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link class="add" @click.stop="addTeacherToSchool(row)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col>
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- <div v-else>Students are loading...</div> -->
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SchoolService from "../services/SchoolService";
import NameSearch from "@/components/NameSearch";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "SchoolTeachers",
  mixins: [flash, scrollTo],
  components: {
    NameSearch,
  },
  data() {
    return {
      schoolId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      schoolTeacherFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "head_teacher", label: "HT?", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
      teachers: [],
      showForm: true,
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOL_TEACHERS: "schools/GET_SCHOOL_TEACHERS",
      RESET_SCHOOLS_STATE: "schools/RESET_SCHOOLS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
      SEARCH_TEACHERS: "searches/GET_TEACHERS_BY_LOCATION",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    hideForm() {
      this.showForm = !this.showForm;
    },
    toggleForm() {
      this.showForm = !this.showForm;
      this.RESET_SEARCH();
    },
    async searchTeachers() {
      await this.SEARCH_TEACHERS();
    },
    async updateSchoolTeacher(params) {
      const payload = await {
        id: params.item.id,
        teacher_uuid: params.item.teacher_uuid,
        school_uuid: this.$route.params.id,
        active: !params.item.active,
      };
      await SchoolService.updateSchoolTeacher(payload);
      await this.GET_SCHOOL_TEACHERS();
    },
    async deleteSchoolTeacher(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this teacher from this school?"
      );
      if (confirmDelete) {
        await SchoolService.deleteSchoolTeacher(params);
        await this.GET_SCHOOL_TEACHERS();
      }
    },
    async addTeacherToSchool(params) {
      console.log("params: ", params);
      const payload = await {
        teacher_uuid: params.item.teacher_uuid,
        school_uuid: this.$route.params.id,
        active: true,
      };
      await SchoolService.addSchoolTeacher(payload);
      await this.scrollTo("school-teachers-alert");
      await this.flashSuccess();
      await this.GET_SCHOOL_TEACHERS();
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      getTeacherSearchResults: "searches/getTeacherSearchResults",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),

    teachersTable: {
      get() {
        console.log(
          "schoolTeachers: ",
          this.$store.state.schools.schoolTeachers
        );
        return this.$store.state.schools.schoolTeachers;
      },
    },
    cleanedSearchResults() {
      const data = this.getTeacherSearchResults.map((k) => ({
        id: k.id,
        teacher_uuid: k.uuid,
        teacher_name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        head_teacher: k.head_teacher,
        active: k.active,
        sex: k.sex,
        created: k.created,
      }));
      return data;
    },
    schoolTeachers: {
      get() {
        return this.$store.state.schools.schoolTeachers;
      },
    },
    rows() {
      if (this.teachers.length > 0) {
        return this.teachers.length;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.schoolTeacherFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.RESET_SEARCH();
    this.GET_SCHOOL_TEACHERS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
